<template>
    <Portal selector="#portal-button-envelope">
        <span v-if="unread.length" class="badge badge-warning">{{unread.length}}</span>
    </Portal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Portal } from "@linusborg/vue-simple-portal";

export default {
    name: "PortalMessageButton",
    components: {
        Portal,
    },
    computed: {
        unread() {
            if (this.me) {
                return Object.keys(this.unreadRooms);
                // return this.freshThreadIds(this.me.id);
            } else {
                return [];
            }
        },
        ...mapGetters({
            me: 'currentAttendee',
            unreadRooms: 'messages/unreadRooms',
            // freshThreadIds: 'messages/freshThreadIds',
        })
    },
    created() {
        const buttonEnvelope = document.getElementById('portal-button-envelope');
        if (buttonEnvelope) {
            buttonEnvelope.innerHTML = '';
        }
    }
}
</script>

<style>

</style>